module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-poj-eb00c4dc0315ff3decebac3823936feb.jpg";